import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { KorviuButtonComponent } from '../korviu-button/korviu-button.component';

@Component({
  selector: 'app-okeey-card-paused-content',
  imports: [TranslatePipe, KorviuButtonComponent],
  template: `
    <div class="whitespace-pre-line">{{ 'balance.okeeyCardPausedDescription' | translate }}</div>
    <div class="mt-6 flex justify-end">
      <korviu-button color="primary" (onclick)="confirm()">
        {{ 'balance.okeeyCardPausedConfirm' | translate }}
      </korviu-button>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OkeeyCardPausedContentComponent {
  private readonly modalRef = inject(NzModalRef);

  confirm(): void {
    this.modalRef.close();
  }
}
